import React, {useContext} from 'react';
import UserContext from '../../context/user-context';
import Spinner from '../UI/Spinner';

const memberInfo = (props) => {
    const userContext = useContext(UserContext);

    let html = <Spinner />;
    if(userContext.user.infos && !userContext.user.account){
        html = (<div>
            <strong className="member-info__name">{userContext.user.infos.firstname} {userContext.user.infos.lastname}</strong>
        </div>);
    } else if (userContext.user.infos && userContext.user.account){
        html = (<div>
            <strong className="member-info__name">{userContext.user.infos.firstname} {userContext.user.infos.lastname}</strong>
            <div className="member-info__desc">{userContext.user.account.name}</div>
        </div>);
    }


    return html;
};


export default memberInfo;

